import { REL_TYPES } from "./app-constants.js";
import { appUrl } from "./url-constants.js";

const getAppUrl = (urlPath) => {
    return `${appUrl()}/${urlPath}`;
};

const getLoans24AppUrl = (urlPath) => {
    return `https://www.loans24.co.in/${urlPath}/`;
};

export const CF_SEO_LINKS = [
    {
        text: "Used car loan",
        url: `${appUrl()}/used-car-loan/`
    },
    {
        text: "Used car loan eligibility",
        url: `${appUrl()}/used-car-loan/#CF_DOCUMENT_REQUIRED`
    },
    {
        text: "Used car loan interest rates",
        url: getLoans24AppUrl("used-car-loan/interest-rate/")
    },
    {
        text: "Used car EMI calculator",
        url: `${appUrl()}/used-car-loan/#CF_LANDING_EMI_CALCULATOR`
    }
];

export const getUsedCarLoanLinks = () => {
    return [
        {
            title: "Overview",
            url: getAppUrl("used-car-loan/")
        },
        {
            title: "Features & Benefits",
            url: getAppUrl("used-car-loan/#CF_EXCLUSIVE_BENEFITS")
        },
        {
            title: "Application Process",
            url: getAppUrl("used-car-loan/#CF_LOAN_STATE")
        },
        {
            title: "EMI Calculator",
            url: getAppUrl("used-car-loan/#CF_LANDING_EMI_CALCULATOR")
        },
        {
            title: "Document & Eligibility",
            url: getAppUrl("used-car-loan/#CF_DOCUMENT_REQUIRED")
        },
        {
            title: "Interest rates & charges",
            url: getLoans24AppUrl("used-car-loan/interest-rate/")
        },
        {
            title: "Why LOANS24?",
            url: getAppUrl("used-car-loan/#CF_SEO_COMPARISON_TABLE")
        }
    ];
};

export const getLoanAgainstCarLinks = () => {
    return [
        {
            title: "Overview",
            url: getLoans24AppUrl("loan-against-car"),
            rel: REL_TYPES.NO_FOLLOW_SPONSORED
        },
        {
            title: "Features & Benefits",
            url: getLoans24AppUrl("loan-against-car/features-and-benefits"),
            rel: REL_TYPES.NO_FOLLOW_SPONSORED
        },
        {
            title: "Calculator",
            url: getLoans24AppUrl("loan-against-car/emi-calculator"),
            rel: REL_TYPES.NO_FOLLOW_SPONSORED
        },
        {
            title: "Document & Eligibility",
            url: getLoans24AppUrl("loan-against-car/eligibility-criteria"),
            rel: REL_TYPES.NO_FOLLOW_SPONSORED
        },
        {
            title: "Application Process",
            url: getLoans24AppUrl("loan-against-car/how-to-apply"),
            rel: REL_TYPES.NO_FOLLOW_SPONSORED
        },
        {
            title: "Interest & Charges",
            url: getLoans24AppUrl("loan-against-car/interest-rate"),
            rel: REL_TYPES.NO_FOLLOW_SPONSORED
        },
        {
            title: "Pay your EMI",
            url: getLoans24AppUrl("digital-payment?utm_source=Loans24&utm_medium=Header_UCL&utm_content=Fetch_Details_Page"),
            rel: REL_TYPES.NO_FOLLOW_SPONSORED
        }
    ];
};

export const getPersonalLoanLinks = () => {
    return [
        {
            title: "Overview",
            url: getLoans24AppUrl("personal-loan"),
            rel: REL_TYPES.NO_FOLLOW_SPONSORED
        },
        {
            title: "Features & Benefits",
            url: getLoans24AppUrl("personal-loan/features-and-benefits"),
            rel: REL_TYPES.NO_FOLLOW_SPONSORED
        },
        {
            title: "EMI Calculator",
            url: getLoans24AppUrl("personal-loan/emi-calculator"),
            rel: REL_TYPES.NO_FOLLOW_SPONSORED
        },
        {
            title: "Document & Eligibility",
            url: getLoans24AppUrl("personal-loan/eligibility-criteria"),
            rel: REL_TYPES.NO_FOLLOW_SPONSORED
        },
        {
            title: "Application Process",
            url: getLoans24AppUrl("personal-loan/how-to-apply"),
            rel: REL_TYPES.NO_FOLLOW_SPONSORED
        },
        {
            title: "Interest & Charges",
            url: getLoans24AppUrl("personal-loan/interest-rate"),
            rel: REL_TYPES.NO_FOLLOW_SPONSORED
        }
    ];
};

export const CF_SEO_DROPDOWN_ITEMS = [
    {
        heading: "Used car loan",
        links: (isOpen) => getUsedCarLoanLinks(isOpen),
        viewType: "LIST",
        showLinkTitle: true
    },
    {
        heading: "Loan against car",
        links: () => getLoanAgainstCarLinks(),
        viewType: "LIST"
    },
    {
        heading: "Personal loan",
        links: () => getPersonalLoanLinks(),
        viewType: "LIST"
    }
];
